type Props = {
  fill: string;
  height: string;
  width: string;
};

const RaffleIcon = ({ fill, height, width }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.39874 14.2984L3.86808 13.7677L9.52494 8.11086L15.8889 14.4748L10.232 20.1317L9.70139 19.601C10.6439 18.1155 10.4673 16.1243 9.17138 14.8284C7.8755 13.5325 5.88423 13.3558 4.39874 14.2984ZM17.3031 13.0606L10.9392 6.69665L13.7676 3.86822L14.4031 4.50378C13.7556 5.92117 14.0152 7.65136 15.1818 8.81797C16.3484 9.98458 18.0786 10.2441 19.496 9.59663L20.1315 10.2322L17.3031 13.0606ZM14.4747 1.7469L15.647 2.91921L17.0612 4.33342L16.596 4.79863C15.8766 5.51801 15.8766 6.68437 16.596 7.40376C17.3154 8.12314 18.4817 8.12314 19.2011 7.40376L19.6663 6.93855L21.0806 8.35277L22.2529 9.52508C22.6434 9.9156 22.6434 10.5488 22.2529 10.9393L10.9392 22.253C10.5486 22.6435 9.91546 22.6435 9.52494 22.253L8.35263 21.0807L6.93842 19.6665L7.75717 18.8477C8.47656 18.1283 8.47656 16.962 7.75717 16.2426C7.03778 15.5232 5.87143 15.5232 5.15204 16.2426L4.33329 17.0613L2.91907 15.6471L1.74676 14.4748C1.35624 14.0843 1.35624 13.4511 1.74676 13.0606L13.0605 1.7469C13.451 1.35638 14.0842 1.35638 14.4747 1.7469Z"
        fill={fill}
      />
    </svg>
  );
};

export default RaffleIcon;
